import {ListProduto} from './list/ListProduto';

import {AddProduto} from './add/AddProduto';
import {AlterProduto} from './add/AlterProduto';
import {DeleteProduto} from './add/DeleteProduto';
 

import {Login} from './other/Login';

const Api={
 Login,

 ListProduto,
 DeleteProduto,
 AlterProduto,
 AddProduto,


}

export default Api;